"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentFormatIntoMimeType = exports.mimeTypeIntoDocumentFormat = exports.DocumentFormat = void 0;
var mime_type_1 = require("@devexpress/utils/lib/utils/mime-type");
var DocumentFormat;
(function (DocumentFormat) {
    DocumentFormat[DocumentFormat["Undefined"] = 0] = "Undefined";
    DocumentFormat[DocumentFormat["PlainText"] = 1] = "PlainText";
    DocumentFormat[DocumentFormat["Rtf"] = 2] = "Rtf";
    DocumentFormat[DocumentFormat["Html"] = 3] = "Html";
    DocumentFormat[DocumentFormat["OpenXml"] = 4] = "OpenXml";
    DocumentFormat[DocumentFormat["Mht"] = 5] = "Mht";
    DocumentFormat[DocumentFormat["WordML"] = 6] = "WordML";
    DocumentFormat[DocumentFormat["OpenDocument"] = 7] = "OpenDocument";
    DocumentFormat[DocumentFormat["ePub"] = 9] = "ePub";
    DocumentFormat[DocumentFormat["Doc"] = 10] = "Doc";
})(DocumentFormat = exports.DocumentFormat || (exports.DocumentFormat = {}));
exports.mimeTypeIntoDocumentFormat = (_a = {},
    _a[mime_type_1.DxMimeType.OpenXml] = DocumentFormat.OpenXml,
    _a[mime_type_1.DxMimeType.Docm] = DocumentFormat.OpenXml,
    _a[mime_type_1.DxMimeType.Rtf] = DocumentFormat.Rtf,
    _a[mime_type_1.DxMimeType.PlainText] = DocumentFormat.PlainText,
    _a);
exports.documentFormatIntoMimeType = (_b = {},
    _b[DocumentFormat.OpenXml] = mime_type_1.DxMimeType.OpenXml,
    _b[DocumentFormat.Rtf] = mime_type_1.DxMimeType.Rtf,
    _b[DocumentFormat.PlainText] = mime_type_1.DxMimeType.PlainText,
    _b);
